<template>
  <div id="prop-facilities" class="prop-facilities">
    <ul class="facilities">
      <li class="facility reviews" v-if="reviews.length > 0" @click="scrollTo">
        <svg class="svg">
          <use xlink:href='#ico-star'/>
        </svg>
        <p v-if="reviews.length === 1" class="link"> {{reviews.length}} review</p>
        <p v-else class="link"> {{reviews.length}} reviews</p>
      </li>
      <li class="facility floorplan" @click="openFloorPlan" v-if="isFloorPlan">
        <svg class="svg">
          <use xlink:href='#icon-floorplan'/>
        </svg>
        <p>Floorplan</p>
      </li>
      <li class="facility" v-if="property.pets || property.max_pets">
        <svg class="svg">
          <use xlink:href='#icon-pet'/>
        </svg>
        <p class="link" v-if="property.pets && !property.max_pets">
          Pets welcome
        </p>
        <p class="link" v-if="property.pets && property.max_pets">
          {{ property.max_pets }} pet{{parseInt(property.max_pets) === 1 ? "":"s"}} welcome
        </p>
      </li>
      <li class="facility" v-if="!property.pets">
        <svg class="svg">
          <use xlink:href='#icon-nopets'/>
        </svg>
        <p class="link">
          No pets
        </p>
      </li>
      <li class="facility" v-if="property.baths > 0">
        <svg class="svg">
          <use xlink:href='#icon-bath'/>
        </svg>
        <p class="link">{{property.baths}} Bathroom{{parseInt(property.baths) === 1 ? "":"s"}}</p>
      </li>
      <li class="facility" v-if="property.wifi">
        <svg class="svg">
          <use xlink:href='#icon-wifi-v2'/>
        </svg>
        <p class="link">WiFi</p>
      </li>
      <li class="facility" v-if="property.hot_tub">
        <svg class="svg">
          <use xlink:href='#icon-hottub'/>
        </svg>
        <p class="link">Hot tub</p>
      </li>
      <li class="facility" v-if="property.open_fire">
        <svg class="svg">
          <use xlink:href='#icon-fire'/>
        </svg>
        <p class="link">Open fire</p>
      </li>
      <li class="facility" v-if="property.parking">
        <svg class="svg">
          <use xlink:href='#icon-parking'/>
        </svg>
        <p class="link">Parking</p>
      </li>
      <li class="facility" v-if="property.swimming_pool">
        <svg class="svg">
          <use xlink:href='#icon-pool'/>
        </svg>
        <p class="link">Swimming pool</p>
      </li>
      <li class="facility" v-if="property.cots">
        <svg class="svg">
          <use xlink:href='#icon-children'/>
        </svg>
        <p class="link">Children welcome</p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    property: Object,
    reviews: Array,
    isFloorPlan: Boolean,
    floorPlanImage: Number
  },
  methods: {
    scrollTo() {
      this.$emit('scrollTo', 'prop-reviews', -20);
      this.$emit('sendTrack', "click-review-button", true)
    },
    openFloorPlan() {
      this.$emit('toggleModal', this.floorPlanImage);
      this.$emit('sendTrack', 'prop-open-floorplan', true);
    }
  }
}
</script>

<style scoped lang="scss">
@import 'app/assets/stylesheets/_vars.scss';

.prop-facilities {
  margin: 1.125rem 1.25rem 1.25rem;

  @media #{$desktop} {
    margin: 1.125rem 0 1.25rem;
  }
}

.facilities {
  display: flex;
  flex-wrap: wrap;
  column-gap: .625rem;
  row-gap: .625rem;
  padding-bottom: 1.25rem;
  border-bottom: 1px solid #D9D9D9;
  position: relative;
  z-index: 2;
}

.facility {
  display: flex;
  transition: .3s;
  list-style: none;
  min-height: auto;
  border-radius: 1rem;
  align-items: flex-end;
  background-color: $col_xlgrey;
  padding: 0.5rem 0.625rem 0.5rem 0.625rem;

  &.reviews {
    background: $col_primary;

    .svg {
      fill: $col_white;
    }
    .link {
      color: $col_white;
    }
  }

  &.floorplan {
    cursor: pointer;
    background: #4B4B4B;
    svg {
      width: 1rem;
      height: 1rem;
    }
    p {
      color: $col_white;
    }
    &:hover {
      background: #666565;
    }
  }

  @media #{$desktop} {
    cursor: default;
    align-items: center;

    p {
      cursor: default;
    }

    &:hover {
      p {
        text-decoration: none;
      }
    }

    &.reviews {
      &:hover{
        cursor: pointer;
        transition: .3s;
        background: #5fadefc9;

        p {
          cursor: pointer;
        }
      }
    }
  }
}

.svg {
  width: 1.25rem;
  height: 1.25rem;
  padding-right: .313rem;
  transition: .3s;
}

.link {
  color: $col_black;
  transition: .3s;
  font-size: .875rem;
  line-height: 1.125rem;
  display: block;
  text-decoration: none;
  text-align: center;

  @media #{$desktop} {
    font-size: 1rem;
    line-height: 1rem;
  }
}
</style>